import {profileInfoSlice} from './profileInfoSlice';

export default profileInfoSlice.reducer;
